import { HOW_IT_WORKS_CONTENT } from "../constants";
import { motion } from 'framer-motion';
import { useTranslation } from "react-i18next";


const HowItWorks = () => {
    const { t } = useTranslation();

    const stepVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.2,
                duration: 0.6,
                ease: "easeOut"
            }
        })
    }

    const localizedSteps = HOW_IT_WORKS_CONTENT.steps.map((step, index) => ({
        ...step,
        title: t(`howItWorks.steps.${index}.title`),
        description: t(`howItWorks.steps.${index}.description`),
    }));

    return (
        <section id="works">
            <div className="max-w-7xl mx-auto px-4">
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                    className="text-center mb-12 border-t border-neutral-800"
                >
                    <h2 className="text-3xl lg:text-6xl mt-20 tracking-tighter text-neutral-600 bg-clip-text ">
                        {t('howItWorks.sectionTitle')}
                    </h2>
                    <p className="mt-4 text-[16px] font-medium text-neutral-500 max-w-xl mx-auto">
                        {t('howItWorks.sectionDescription')}
                    </p>
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.2
                            }
                        }
                    }}
                    className=""
                >
                    {localizedSteps.map((step, index) => (
                        <motion.div
                            custom={index}
                            variants={stepVariants}
                            key={index}
                            className="flex flex-col justify-between"
                        >
                            {/* Heading with Icon */}
                            <div className="flex items-start mb-4 space-y-4 ">
                                <div className="text-StandardSEPM bg-StandardSEPM_fade2 p-3 rounded-full flex-shrink-0 mt-4">
                                    {step.icon}
                                </div>
                                <div className="ml-4">
                                    <h3 className="text-lg font-medium font-Montserrat">{step.title}</h3>
                                    <p className="text-neutral-500 font-medium mt-2">{step.description}</p>
                                </div>
                            </div>


                        </motion.div>
                    ))}
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                    className="text-center mt-8 "
                >
                    <p className="font-semibold text-[1rem] text-neutral-600 max-w-xl mx-auto">
                        {t('howItWorks.lastStep')}
                    </p>
                </motion.div>
            </div>
        </section>
    )
}

export default HowItWorks